<template>

</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Logout',
  data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    }
  },
  mounted() {
    this.signOut()
  },
  methods: {
    signOut: function() {
      firebase.auth().signOut().then(
        (resposta) => {
          this.$store.commit('SET_TOKEN', null)
          this.$store.commit('SET_USER', null)
          window.localStorage.setItem('token', null)
          window.localStorage.setItem('user', null)
          this.$router.push('/login')
        }
      )
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// Logout.vue?23dbb252